import React from 'react';
import { Edit, ErrorOutline, IconCheckmark } from '@insurancemenu/imenu-components-lib/dist/icons';
import { SubscriberProductLineType } from 'types/electionService';

interface PLButtonConfig {
  title: string;
  icon: JSX.Element;
}

interface PLButtonConfigByValidity {
  valid: PLButtonConfig;
  invalid: PLButtonConfig;
}

export const productLineActionButtonConfig: Record<SubscriberProductLineType, PLButtonConfigByValidity | null> =
  Object.freeze({
    SELECTED: {
      valid: {
        title: 'Update Form',
        icon: <Edit />,
      },
      invalid: {
        title: 'Complete Election',
        icon: <IconCheckmark />,
      },
    },
    WAIVED: {
      valid: {
        title: 'Update Waiver Form',
        icon: <Edit />,
      },
      invalid: {
        title: 'Fill Waiver Form',
        icon: <ErrorOutline />,
      },
    },
    NOT_SELECTED: null,
  });
